const version = 'v1';
const publico = `/${version}/public`;

export const ENDPOINT_CERTIFICADO = `${publico}/certificado`;
export const PRODUTOS_ENDPOINT = `${version}/produtos`;
export const PRODUTO_ENDPOINT = `${version}/produto`;
export const PRODUTOS_GRID_ENDPOINT = `${version}/produtos/grid`;
export const USER_ENDPOINT = `${version}/usuario`;
export const CURSO_ENDPOINT = `${version}/curso`;
export const TEMAS_ENDPOINT = `${version}/temas`;
export const TEMAS_ATIVOS_ENDPOINT = `${TEMAS_ENDPOINT}/ativos`;
export const TAGS_PRODUTO_ENDPOINT = `${PRODUTO_ENDPOINT}/tags`;
export const CERTIFICADOS_GRID_ENDPOINT = `${version}/certificados/grid`
export const CERTIFICADOS_ERROS_GRID_ENDPOINT = `${version}/certificados/erros/grid`
export const CERTIFICADO_ENDPOINT = `${version}/certificado`
export const CERTIFICADOS_ENDPOINT = `${version}/certificados`
export const VERSIONS_ENPOINT = `${version}/public/app/versions`;
export const CERTIFICADO_TEMPLATE = `${version}/certificado-template`;
export const CERTIFICADO_ANEXO = `${version}/certificado-anexo`;
export const CERTIFICADO_ANEXOS = `${version}/certificado-anexos`;

export const actionRequest = {
  show: 'show',
  update: 'update',
  create: 'create',
  delete: 'delete',
  newFromThis: 'newFromThis',
  menagement: 'menagement'
}
